/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_USER_LIST = gql`
query Data($input: GetUserListInput) {
  getUserList(input: $input) {
    data {
      address {
        addressLine1
        addressLine2
      }
      lastName
      fullName
      firstName
      accountStatus
      email
      id
      createdAt
      role {
        name
        state
        uuid
      }
      gender
      creatorUser {
        id
        firstName
        fullName
      }
      vuid
      userId
      suspended
    }
    pageSize
    totalCount
    totalPages
    currentPage
  }
}
`;

// $input: RoleListInput

// getListOfRole(input: $input) {
//   totalCount
//   data
// }
